import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import i18next from 'i18next';
import Sidebar from './components/Sidebar';
import { downloadPDF, gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import { postApi } from './api/services';
import MainLoader from './components/MainLoader';
import { useSelector } from 'react-redux';
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/webpack";

const DoctorReport = () => {

  const containerRef = useRef(null);
  const location = useLocation()
  const navigate = useNavigate()
  const [prescriptionData, setPrescriptionData] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const locale = useSelector((state) => state.language.langData)
  
  useEffect(() => {
    if(location.state.prescription.prescription_number) {
      getPrescriptionImage()
    } else {
      navigate('/reports')
    }
  }, [])

  const getPrescriptionImage = async () => {
    try {
      setIsLoading(true)
      let params = {
        slipid: location.state.prescription.prescription_number
      }
      console.log("get_prescriptions_by_slipid params", params);
      let res = await postApi('get_prescriptions_by_slipid', params)
      console.log("get_prescriptions_by_slipid res", res);
      if(res?.error) {
        setIsLoading(false)
        serviceDown()
        logEvent('fail', 'prescription not found')
      } else {
        setIsLoading(false)
        setPrescriptionData(res?.prescriptions[0])
        if(res?.prescriptions[0]?.file_type.toUpperCase() === 'PDF') {
          res?.prescriptions[0]?.stage_prescription_pdf && renderPdf(res?.prescriptions[0]?.stage_prescription_pdf)
        }
        logEvent('success')
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
      logEvent('fail', 'prescription not found')
    } 
  }

  const renderPdf = async (prescriptionData) => {
    try {
      const binary = atob(prescriptionData);
      const pdf = await getDocument({ data: binary }).promise;
      const container = containerRef.current;
      container.innerHTML = ""; // clear before rendering
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });
        // create canvas for each page
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        container.appendChild(canvas);
        await page.render({ canvasContext: context, viewport }).promise;
      }
    } catch (err) {
      console.error("PDF render error:", err);
    }
  };

  const logEvent = async (status, err) => {
    try {
      await trackEvent('prescription_viewed', status, err ? err : " ", localStorage.getItem('phno'))
      await gTagTracking('prescription_viewed', {
        action: status,
        error: err ? err : " ",
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err); 
    }
  }

  const downloadReport = () => {
    downloadPDF(prescriptionData?.stage_prescription_pdf, `${location.state.prescription.prescription_number}_Doctor_Report`)
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='doctorReportPage'>
        <div className="photo-container main-section-container prescription-page">
          <Grid
            container
            spacing={0}
            className="d-flex justify-content-start align-items-center"
          >
            <Grid item xs={1} className="">
              <div className="d-flex justify-content-start align-items-center">
                <span
                  className="backButtonDiv"
                  onClick={() => navigate(-1)}
                >
                  <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={10}
              className="d-flex justify-content-center align-items-center reportPageHead"
            >
              <Typography variant="h6" className="title ml-0px">
                {i18next.t("Doctor Report")}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Sidebar />
            </Grid>
          </Grid>
          {
            prescriptionData && Object.keys(prescriptionData).length > 0 && prescriptionData?.stage_prescription_pdf ?
              <>
                <div className='userprescriptionpage d-flex justify-content-center align-items-center flex-direction-column'>
                  {
                    prescriptionData?.file_type.toUpperCase() === 'PDF' ?
                      <div
                        ref={containerRef}
                        className='mt-5px pdfPrescriptionContainer'
                      ></div> 
                        :
                    prescriptionData?.file_type.toUpperCase() === 'IMAGE' ?
                      <img className='mb-20px' src={`data:image/jpeg;base64,${prescriptionData?.stage_prescription_pdf}`}/> 
                        :
                      <div
                        ref={containerRef}
                        className='mt-5px pdfPrescriptionContainer'
                      ></div>
                  }
                </div>
                <Button 
                  className='commonButton'
                  onClick={() => downloadReport()}
                >
                  {i18next.t(
                    locale === 'en' ?
                      "Download Report" :
                    locale === 'fr' ?
                      "Download Report" :
                    locale === 'es' ?
                      "Download Report" :
                    "Download Report"
                  )}
                </Button>
              </>
                : 
              <div className="nodatadiv">
                <Typography className="">
                  {i18next.t("No report found")}
                </Typography>
              </div>
          }
        </div>  
      </div>
    </>
  )
}

export default DoctorReport